package kz.dentalcrm.app.screens.employees.edit.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface EditEmployeeSideEffect : ViewSideEffect {
    data object UpdateSuccess : EditEmployeeSideEffect
    data object DeleteSuccess : EditEmployeeSideEffect
    data class ShowError(val message: String) : EditEmployeeSideEffect
}
